import '../css/index.scss';
import $ from 'jquery';


/**js**/
'use strict';

let windowWidth = $(window).width();
let windowHeight = $(window).height();

let LoadEnd = false;
let nowPage = '';
let nextPage = '';
let adjust = null;
let saveStopPOS = 0;
const BREAKPOINT_SP = 768;


const setup = () => {

  // UA
  const _ua = (function(u){
    return {
      Tablet:(u.indexOf("windows") != -1 && u.indexOf("touch") != -1 && u.indexOf("tablet pc") == -1)
        || u.indexOf("ipad") != -1
        || (u.indexOf("android") != -1 && u.indexOf("mobile") == -1)
        || (u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1)
        || u.indexOf("kindle") != -1
        || u.indexOf("silk") != -1
        || u.indexOf("playbook") != -1,
      Mobile:(u.indexOf("windows") != -1 && u.indexOf("phone") != -1)
        || u.indexOf("iphone") != -1
        || u.indexOf("ipod") != -1
        || (u.indexOf("android") != -1 && u.indexOf("mobile") != -1)
        || (u.indexOf("firefox") != -1 && u.indexOf("mobile") != -1)
        || u.indexOf("blackberry") != -1
    }
  })(window.navigator.userAgent.toLowerCase());

  if(!_ua.Mobile && !_ua.Tablet){
  }

  // アンカーリンクを取得
  // const anchors = document.querySelectorAll('.nav-item-link');
  // anchors.forEach(anchor => {
  //   anchor.addEventListener('click', function (e) {

  //     e.preventDefault(); // urlを変更しないようにする
  //     lenis.scrollTo( '#' + this.getAttribute('data-target')) // スクロール
  //   });
  // });

};

window.addEventListener('load',function(){

  // let vw = window.innerWidth;
  // document.documentElement.style.setProperty('--vw', `${vw}px`);
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  if (windowWidth <= BREAKPOINT_SP) {
    adjust = windowHeight * .25;
  } else {
    adjust = windowHeight * .15;
  }

  // progressbar.js
  var ProgressBar = require('progressbar.js');
  var line = new ProgressBar.Line('#loading .progressBar', {
    strokeWidth: 1,
    easing: 'easeInOut',
    duration: 1400,
    color: '#686260',
    trailColor: '#F5F5F5',
    trailWidth: 1,
    svgStyle: {width: '100.0%', height: '20.0%'},
  });

  line.animate(1.0, function () {

    // Loading fadeout
    $("#loading").delay(400).fadeOut(800);

    setup();

    const body = document.querySelector( 'body' );
    setTimeout(() => {
      body.classList.add('opening');
      setTimeout(() => {
        body.classList.add('complete');
        body.classList.remove('opening');
      }, 4000);
    }, 400);
  });

});


// resize
var resizeTimer;
var interval = 1000;

window.addEventListener('resize',function() {

  if (resizeTimer !== false) {
    clearTimeout(resizeTimer);
  }

  resizeTimer = setTimeout(function() {
    windowHeight = $(window).height();

    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

  }, interval);

});


$(function(){

  // drawer-nav

  const gHeader = $('.js-header');
  const gNavi = $('.js-drawer-nav');
  const gNaviButton = $('.js-drawer-button');
  const gNaviAnchor = $('.drawer-nav .nav-item-link');

  gNaviButton.on('click', function(){
    gNaviButton.toggleClass('-active');
    gNavi.toggleClass('-active');
    gHeader.toggleClass('-active');
  });

  // gNaviAnchor.on('click', function(){
  //   gNaviButton.toggleClass('-active');
  //   gNavi.toggleClass('-active');
  //   headerLogo.toggleClass('-active');
  // });

});

/*----------------------------------------------------------
  checkElement
----------------------------------------------------------*/

var elArr = { "startY":1926,"number":[
  [26,57,25,56,26,57,27,58,29,59,30,0],
  [31,2,30,1,31,2,32,3,34,4,35,5],
  [36,7,36,7,37,8,38,39,40,10,41,11],
  [42,13,41,12,42,13,43,14,45,15,46,16],
  [47,18,46,17,47,18,48,19,50,20,51,21],
  [52,23,51,22,52,23,53,24,55,25,56,26],
  [57,28,57,28,58,29,59,30,1,31,2,32],
  [3,34,2,33,3,34,4,35,6,36,7,37],
  [8,39,7,38,8,39,9,40,11,41,12,42],
  [13,44,12,43,13,44,14,45,16,46,17,47],
  [18,49,18,49,19,50,20,51,22,52,23,53],
  [24,55,23,54,24,55,25,56,27,57,28,58],
  [29,0,28,59,29,0,30,1,32,2,33,3],
  [34,5,33,4,34,5,35,6,37,7,38,8],
  [39,10,39,10,40,11,41,12,43,13,44,14],
  [45,16,44,15,45,16,46,17,48,18,49,19],
  [50,21,49,20,50,21,51,22,53,23,54,24],
  [55,26,54,25,55,26,56,27,58,28,59,29],
  [0,31,0,31,1,32,2,33,4,34,5,35],
  [6,37,5,36,6,37,7,38,9,39,10,40],
  [11,42,10,41,11,42,12,43,14,44,15,45],
  [16,47,15,46,16,47,17,48,19,49,20,50],
  [21,52,21,52,22,53,23,54,25,55,26,56],
  [27,58,26,57,27,58,28,59,30,0,31,1],
  [32,3,31,2,32,3,33,4,35,5,36,6],
  [37,8,36,7,37,8,38,9,40,10,41,11],
  [42,13,42,13,43,14,44,15,46,16,47,17],
  [48,19,47,18,48,19,49,20,51,21,52,22],
  [53,24,52,23,53,24,54,25,56,26,57,27],
  [58,29,57,28,58,29,59,30,1,31,2,32],
  [3,34,3,34,4,35,5,36,7,37,8,38],
  [9,40,8,39,9,40,10,41,12,42,13,43],
  [14,45,13,44,14,45,15,46,17,47,18,48],
  [19,50,18,49,19,50,20,51,22,52,23,53],
  [24,55,24,55,25,56,26,57,28,58,29,59],
  [30,1,29,0,30,1,31,2,33,3,34,4],
  [35,6,34,5,35,6,36,7,38,8,39,9],
  [40,11,39,10,40,11,41,12,43,13,44,14],
  [45,16,45,16,46,17,47,18,49,19,50,20],
  [51,22,50,21,51,22,52,23,54,24,55,25],
  [56,27,55,26,56,27,57,28,59,29,0,30],
  [1,32,0,31,1,32,2,33,4,34,5,35],
  [6,37,6,37,7,38,8,39,10,40,11,41],
  [12,43,11,42,12,43,13,44,15,45,16,46],
  [17,48,16,47,17,48,18,49,20,50,21,51],
  [22,53,21,52,22,53,23,54,25,55,26,56],
  [27,58,27,58,28,59,29,0,31,1,32,2],
  [33,4,32,3,33,4,34,5,36,6,37,7],
  [38,9,37,8,38,9,39,10,41,11,42,12],
  [43,14,42,13,43,14,44,15,46,16,47,17],
  [48,19,48,19,49,20,50,21,52,22,53,23],
  [54,25,53,24,54,25,55,26,57,27,58,28],
  [59,30,58,29,59,30,0,31,2,32,3,33],
  [4,35,3,34,4,35,5,36,7,37,8,38],
  [9,40,9,40,10,41,11,42,13,43,14,44],
  [15,46,14,45,15,46,16,47,18,48,19,49],
  [20,51,19,50,20,51,21,52,23,53,24,54],
  [25,56,24,55,25,56,26,57,28,58,29,59],
  [30,1,30,1,31,2,32,3,34,4,35,5],
  [36,7,35,6,36,7,37,8,39,9,40,10],
  [41,12,40,11,41,12,42,13,44,14,45,15],
  [46,17,45,16,46,17,47,18,49,19,50,20],
  [51,22,51,22,52,23,53,24,55,25,56,26],
  [57,28,56,27,57,28,58,29,0,30,1,31],
  [2,33,1,32,2,33,3,34,5,35,6,36],
  [7,38,6,37,7,38,8,39,10,40,11,41],
  [12,43,12,43,13,44,14,45,16,47,17,47],
  [18,49,17,48,18,49,19,50,21,51,22,52],
  [23,54,22,53,23,54,24,55,26,56,27,57],
  [28,59,27,58,28,59,29,0,31,1,32,2],
  [33,4,33,4,34,5,35,6,37,7,38,8],
  [39,10,38,9,39,10,40,11,42,12,43,13],
  [44,15,43,14,44,15,45,16,47,17,48,18],
  [49,20,48,19,49,20,50,21,52,22,53,23],
  [54,25,54,25,55,26,56,27,58,28,59,29],
  [0,31,59,30,0,31,1,32,3,33,4,34],
  [5,36,4,35,5,36,6,37,8,38,9,39],
  [10,41,9,40,10,41,11,42,13,43,14,44],
  [15,46,15,46,16,47,17,48,19,49,20,50],
  [21,52,20,51,21,52,22,53,24,54,25,55],
  [25,57,25,56,26,57,27,58,29,59,30,53],
  [30,2,30,1,31,2,32,3,34,4,35,5],
  [36,7,36,7,37,8,38,9,40,10,41,11],
  [42,13,41,12,42,13,43,14,45,15,46,16],
  [47,18,46,17,47,18,48,19,50,20,51,21],
  [52,23,51,22,52,23,53,24,55,25,56,26],
  [57,28,57,28,58,29,59,30,1,31,2,32],
  [3,34,2,33,3,34,4,35,6,36,7,37],
  [8,39,7,38,8,39,9,40,11,41,12,42],
  [13,44,12,43,13,44,14,45,16,46,17,47],
  [18,49,18,49,19,50,20,51,22,52,23,53],
  [24,55,23,54,24,55,25,56,27,57,28,58],
  [29,60,28,59,29,60,30,1,32,2,33,3],
  [34,5,33,4,34,5,35,6,37,7,38,8],
  [39,10,39,10,40,11,41,12,43,13,44,14],
  [45,16,44,15,45,16,46,17,48,18,49,19],
  [50,21,49,20,50,21,51,22,53,23,54,24],
  [55,26,54,25,55,26,56,27,58,28,59,29],
  [60,31,60,31,1,32,2,33,4,34,5,35],
  [6,37,5,36,6,37,7,38,9,39,10,40],
]}


var e;
if (window.ontouchstart === null) {
	e = 'touchstart';
} else{
	e = 'click';
}

const checkElementBtns = document.querySelectorAll('#btn_submit');
checkElementBtns.forEach(checkElementBtn => {
  checkElementBtn.addEventListener(e, function() {
    checkElements();
  });
});

function checkElements(){
  var stY = elArr.startY;

  var inY = $('#Birth_Year').val();
  var inM = $('#Birth_Month').val();
  var inD = $('#Birth_Day').val()*1;

  var element_base_num = elArr.number[inY - stY][inM - 1];
  var element_num = element_base_num + inD;
  if(element_num > 60){
    element_num = element_num - 60;
  }

  var elValNumber = Math.ceil(element_num / 10)-1;
  var elPath=['https://ac.ebis.ne.jp/tr_set.php?argument=OmMW8PaL&ai=a67b430f7c005f','https://ac.ebis.ne.jp/tr_set.php?argument=OmMW8PaL&ai=a67b43136d5d6a','https://ac.ebis.ne.jp/tr_set.php?argument=OmMW8PaL&ai=a67b430b80bae2','https://ac.ebis.ne.jp/tr_set.php?argument=OmMW8PaL&ai=a67b43166251de','https://ac.ebis.ne.jp/tr_set.php?argument=OmMW8PaL&ai=a67b4319850571','https://ac.ebis.ne.jp/tr_set.php?argument=OmMW8PaL&ai=a67b431df9d9df'];
  // var elPath=['https://www.wwdjapan.com/s/2028949','https://www.wwdjapan.com/s/2028963','https://www.wwdjapan.com/s/2028948','https://www.wwdjapan.com/s/2028951','https://www.wwdjapan.com/s/2028952','https://www.wwdjapan.com/s/2028958'];
  //var elPath=['earth','gold','fire','wind','tree','water'];
  //var elTex=['EARTH（土）','GOLD（金）','FIRE（火）','WIND（風）','TREE（木）','WATER（水）'];

  // console.log("YMD",inY,inM,inD)
  // console.log("base",element_base_num)
  // console.log("base+day",elVal)
  // console.log(elValNumber)
  // console.log(elTex[elValNumber])
  // console.log("あなたのエレメントは"+elTex[elValNumber])

  //var MM = ( '00' + inM ).slice( -2 );
  //var DD = ( '00' + inD ).slice( -2 );
  //var formYMD = inY+MM+DD;
  //setDataLayerEvent(formYMD);

  var _h = elPath[elValNumber]
  // console.log(elPath[elValNumber])
  window.location.href = _h
  return false
}

//function setDataLayerEvent(_v){
//  window.dataLayer = window.dataLayer || [];
//  window.dataLayer.push({
//    event: 'descEvent',
//    event_properties: {
//      category:'elements',
//      action: 'click',
//      label: _v
//    }
//  });
//}

/*----------------------------------------------------------
Google Analytics
----------------------------------------------------------*/

$(function() {

  var url = location.href;
  var pvData = [];

  $('[data-preview]').each(function() {
    var position = $(this).offset().top;
    var data = $(this).attr('data-preview');
    pvData.push({position: position, data: data});
    //console.log(pvData[0].position);
  });


  $(window).on('orientationchange scroll load resize', function(){
    var windowHeight = $(window).height();
    var scrollPosition = $(window).scrollTop();

    $('[data-preview]').not('.processed').each(function() {
      var position = $(this).offset().top - windowHeight * .5;
      var data = $(this).attr('data-preview');
      if (scrollPosition > position) {
        $(this).addClass('processed');
        GAsend(data);
      }
    });
  });

  function GAsend(data){
    var PATH = '#' + data;
    ga('set', 'location', url + PATH);
    ga('send', 'pageview');
    //console.log('GAsend: ' + url + PATH );
  }

});
